"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8528],{

/***/ 28528:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L": function() { return /* binding */ SeoGlobalNavbar; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./node_modules/@care/navigation/dist/components/GlobalNavIA/VisitorHeaderDataProvider/VisitorHeaderDataProvider.js + 3 modules
var VisitorHeaderDataProvider = __webpack_require__(77651);
// EXTERNAL MODULE: ./node_modules/@care/navigation/dist/components/GlobalNavIA/VisitorSEOHeader/VisitorSEOHeader.js + 22 modules
var VisitorSEOHeader = __webpack_require__(81726);
// EXTERNAL MODULE: ./src/lib/analyticsHelper.tsx
var analyticsHelper = __webpack_require__(883);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
;// CONCATENATED MODULE: ./src/helpers/navigationMenuContent/getMoreInfoCommonLinks.ts
/**
 *
 *  This function generates an array of common links for the "More Info" section
 *  of a navigation menu. It includes links for plans and pricing, safety center,
 *  and employer-sponsored benefits.
 *  @param baseURL - The base URL for the application.
 *  @returns An array of link objects, each containing href, id, kind, and value.
 */ var getMoreInfoCommonLinks = function(baseURL) {
    return [
        {
            href: "".concat(baseURL, "/app/vhp/plans-and-pricing"),
            id: "plans-and-pricing",
            kind: "link",
            value: "Plans & pricing"
        },
        {
            href: "".concat(baseURL, "/about/safety/"),
            id: "safety-center",
            kind: "link",
            value: "Safety center"
        },
        {
            href: "".concat(baseURL, "/app/ent-enrollment/member-enrollment/welcome"),
            id: "employer-sponsored-benefits",
            kind: "link",
            value: "Employer-sponsored benefits"
        }, 
    ];
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/lodash-es/capitalize.js
var capitalize = __webpack_require__(26786);
;// CONCATENATED MODULE: ./src/helpers/navigationMenuContent/convertSeoNavLinkToVgnLink.ts


var titleMap = Object.freeze({
    Jobs: "All jobs",
    "Hospice care": "Hospice support",
    "Dog daycare": "Doggy day care",
    "Move out cleaning services": "Move-in/move-out cleaning",
    "House cleaners": "House cleaning"
});
/**
 *
 *  Converts a SEO navigation link item to a LinkKind type.
 *  This function takes a base URL and a navigation link item, and returns an object
 *  that conforms to the LinkKind type used in the navigation menu.
 *  @param baseURL - The base URL to prepend to the link.
 *  @param navigationLinkItem - The navigation link item to map.
 *  @param linkType - The type of link, either 'primary' or 'secondary'.
 *  @returns An object representing the LinkKind type.
 */ var convertSeoNavLinkToVgnLink = function(baseURL, navigationLinkItem, linkType) {
    var title = (0,capitalize/* default */.Z)(navigationLinkItem.title);
    var _title;
    var finalTitle = (_title = titleMap[title]) !== null && _title !== void 0 ? _title : title;
    var isActivitiesAndCamps = finalTitle === "Activities & camps";
    var id = finalTitle.toLowerCase().replace(/\s+/g, "-");
    return (0,_object_spread/* default */.Z)({
        id: id,
        value: finalTitle,
        href: "".concat(baseURL).concat(navigationLinkItem.urlPath),
        kind: "link",
        linkType: linkType
    }, isActivitiesAndCamps && {
        tag: "New"
    });
};

;// CONCATENATED MODULE: ./src/helpers/navigationMenuContent/getVerticalIntroductoryLink.ts
/**
 *
 * This function generates a link object for a specific vertical's introductory page.
 * It takes a base URL and a vertical key, and returns an object containing the link's
 * href, id, kind, and value.
 *  @param baseURL - The base URL for the application.
 *  @param verticalKey - The key representing the vertical (e.g., 'childCareLinks', 'seniorCareLinks').
 *  @returns An object containing the link's href, id, kind, and value.
 *  @example
 *  const link = getVerticalIntroductoryLink('https://example.com', 'childCareLinks');
 *  // link will be:
 *  // {
 *  //   href: 'https://example.com/child-care',
 *  //   id: 'intro-to-child-care',
 *  //   kind: 'link',
 *  //   value: 'Intro to child care'
 *  // }
 */ var getVerticalIntroductoryLink = function(baseURL, verticalKey) {
    var verticalMap = Object.freeze({
        childCareLinks: {
            linkSegment: "child-care",
            titleSegment: "child care"
        },
        seniorCareLinks: {
            linkSegment: "senior-care",
            titleSegment: "senior care"
        },
        petCareLinks: {
            linkSegment: "pet-care",
            titleSegment: "pet care"
        },
        tutoringLinks: {
            linkSegment: "tutoring",
            titleSegment: "tutoring"
        },
        housekeepingLinks: {
            linkSegment: "housekeeping",
            titleSegment: "housekeeping"
        },
        adultCareLinks: {
            linkSegment: "adult-care",
            titleSegment: "adult care"
        }
    });
    var _verticalKey;
    // Default to childCareLinks if the key is not found
    var vertical = (_verticalKey = verticalMap[verticalKey]) !== null && _verticalKey !== void 0 ? _verticalKey : verticalMap.childCareLinks;
    return {
        href: "".concat(baseURL, "/").concat(vertical.linkSegment),
        id: "intro-to-".concat(vertical.linkSegment),
        kind: "link",
        value: "Intro to ".concat(vertical.titleSegment)
    };
};

;// CONCATENATED MODULE: ./src/helpers/navigationMenuContent/buildVgnLinkList.ts



var buildVgnLinkList = function(baseURL, key, linkList, isLargeViewport) {
    var linkType = key === "jobsLinks" ? "secondary" : "primary";
    var vgnLinkList = linkList.map(function(link) {
        return convertSeoNavLinkToVgnLink(baseURL, link, linkType);
    });
    // Add a "View all categories" link to the tutoring vertical.
    if (key === "tutoringLinks") {
        vgnLinkList.push({
            kind: "link",
            id: "view-all-categories",
            href: "".concat(baseURL, "/care-directory#care"),
            value: "View all categories",
            linkType: "primary"
        });
    }
    // Add a "View all categories" link to the jobs vertical.
    if (key === "jobsLinks") {
        vgnLinkList.push({
            kind: "link",
            id: "view-all-categories",
            href: "".concat(baseURL, "/care-directory#jobs"),
            value: "View all categories",
            linkType: "secondary"
        });
    }
    // Add an introductory link to the beginning of vgnLinkList if the viewport is not large.
    if (key !== "jobsLinks" && !isLargeViewport) {
        var introductoryLink = getVerticalIntroductoryLink(baseURL, key);
        return [
            introductoryLink
        ].concat((0,_to_consumable_array/* default */.Z)(vgnLinkList));
    }
    return vgnLinkList;
};

// EXTERNAL MODULE: ./node_modules/@care/navigation/dist/components/GlobalNavIA/VisitorHeaderDataProvider/data/findCareData.js
var findCareData = __webpack_require__(97226);
;// CONCATENATED MODULE: ./src/helpers/navigationMenuContent/createMoreInfoColumn.ts


/**
 * This function creates a "More info" column for the navigation menu.
 * It includes a label, a vertical introductory link, and common links for the specified key.
 * @param baseURL - The base URL for the application.
 * @param key - The key representing the vertical category (e.g., 'childCareLinks').
 * @param moreInfoCommonLinks - An array of common links to be included in the "More info" column.
 * @returns A GroupKind object representing the "More info" column.
 */ var createMoreInfoColumn = function(baseURL, key, moreInfoCommonLinks) {
    var moreInfoLabel = {
        kind: "label",
        id: "more-info-label",
        value: "More info"
    };
    var verticalIntroductoryLink = getVerticalIntroductoryLink(baseURL, key);
    return {
        id: "more-info-column",
        kind: "group",
        items: [
            moreInfoLabel,
            verticalIntroductoryLink
        ].concat((0,_to_consumable_array/* default */.Z)(moreInfoCommonLinks))
    };
};

;// CONCATENATED MODULE: ./src/helpers/navigationMenuContent/buildFindCareVerticalSection.ts


var keyToCareCategoryMap = Object.freeze({
    childCareLinks: findCareData/* CareCategory.ChildCare */.N.ChildCare,
    seniorCareLinks: findCareData/* CareCategory.SeniorCare */.N.SeniorCare,
    adultCareLinks: findCareData/* CareCategory.AdultCare */.N.AdultCare,
    petCareLinks: findCareData/* CareCategory.PetCare */.N.PetCare,
    housekeepingLinks: findCareData/* CareCategory.Housekeeping */.N.Housekeeping,
    tutoringLinks: findCareData/* CareCategory.Tutoring */.N.Tutoring
});
var buildFindCareVerticalSection = function(baseURL, key, vgnLinkList, isLargeViewport, moreInfoCommonLinks) {
    var verticalSection = [
        {
            id: "".concat(keyToCareCategoryMap[key], "-vertical"),
            kind: "group",
            items: vgnLinkList
        }, 
    ];
    // Create and add a "More info" column to the vertical section for large viewports.
    if (isLargeViewport) {
        verticalSection.push(createMoreInfoColumn(baseURL, key, moreInfoCommonLinks));
    }
    return verticalSection;
};

;// CONCATENATED MODULE: ./src/helpers/navigationMenuContent/getFindCareMenuContent.ts




var keyToSectionTitleMap = Object.freeze({
    childCareLinks: "Child care",
    seniorCareLinks: "Senior care",
    adultCareLinks: "Adult care",
    petCareLinks: "Pet care",
    housekeepingLinks: "Housekeeping",
    tutoringLinks: "Tutoring"
});
var sortVerticalOrder = Object.freeze({
    childCareLinks: 1,
    seniorCareLinks: 2,
    adultCareLinks: 3,
    petCareLinks: 4,
    housekeepingLinks: 5,
    tutoringLinks: 6
});
/**
 * Generates the content for the "Find Care" menu section in the navigation.
 * It builds a structured array of vertical sections based on the provided navigation link section.
 * Each vertical section contains links related to a specific care category.
 * If the viewport is not large, common links will be added below the vertical sections.
 * @param baseURL - The base URL for the application.
 * @param navigationLinkSection - The section containing SEO navigation links.
 * @param isLargeViewport - A boolean indicating if the viewport is large. Defaults to false.
 * @returns An object containing the structured find care menu links.
 */ var getFindCareMenuContent = function(baseURL, navigationLinkSection) {
    var isLargeViewport = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var moreInfoCommonLinks = getMoreInfoCommonLinks(baseURL);
    var findCareContent = [];
    Object.entries(navigationLinkSection)// filter out __typename and jobsLinks keys
    .filter(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 1), key = _param[0];
        return key !== "__typename" && key !== "jobsLinks";
    })// sort by the predefined vertical order
    .sort(function(param, param1) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 1), a = _param[0], _param1 = (0,_sliced_to_array/* default */.Z)(param1, 1), b = _param1[0];
        var _a, _b;
        return ((_a = sortVerticalOrder[a]) !== null && _a !== void 0 ? _a : 0) - ((_b = sortVerticalOrder[b]) !== null && _b !== void 0 ? _b : 0);
    }).forEach(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], linkList = _param[1];
        var vgnLinkList = buildVgnLinkList(baseURL, key, linkList, isLargeViewport);
        var verticalSection = buildFindCareVerticalSection(baseURL, key, vgnLinkList, isLargeViewport, moreInfoCommonLinks);
        // Add the vertical section to findCareContent array.
        findCareContent.push({
            id: keyToCareCategoryMap[key],
            title: keyToSectionTitleMap[key],
            items: verticalSection
        });
    });
    // Add the "More Info" common links to the findCareContent if the viewport is not large.
    if (!isLargeViewport) {
        findCareContent.push({
            id: "more-info",
            kind: "group",
            items: moreInfoCommonLinks
        });
    }
    return {
        id: "find-care",
        title: "Find care",
        items: findCareContent
    };
};

;// CONCATENATED MODULE: ./src/helpers/navigationMenuContent/getStartedCommonLinks.ts
/**
 *
 *  This function generates an array of common links for the "Get Started" section
 *  of a navigation menu. It includes links for becoming a caregiver, success on Care.com
 *  and accessing the safety center.
 *  @param baseURL - The base URL for the application.
 *  @returns An array of link objects, each containing kind, id, href, value, and linkType.
 *
 */ var getStartedCommonLinks = function(baseURL) {
    return [
        {
            kind: "label",
            value: "Get started",
            id: "get-started"
        },
        {
            kind: "link",
            id: "become-caregiver",
            href: "".concat(baseURL, "/hiw/caregivers"),
            value: "Become a caregiver",
            linkType: "primary",
            bold: true
        },
        {
            kind: "link",
            id: "success-on-care",
            href: "".concat(baseURL, "/hiw/caregivers/new-provider-education"),
            value: "Success on Care.com",
            linkType: "primary"
        },
        {
            kind: "link",
            id: "safety-center",
            href: "".concat(baseURL, "/about/safety"),
            value: "Safety center",
            linkType: "primary"
        }, 
    ];
};

;// CONCATENATED MODULE: ./src/helpers/navigationMenuContent/getFindJobsMenuContent.ts




/**
 * Generates the "Find Jobs" menu links based on the provided base URL and navigation link section.
 *
 * @param {string} baseURL - The base URL for the application.
 * @param {SEONavigationLinkSection} navigationLinkSection - The section containing SEO navigation links.
 * @returns {VisitorHeaderDataProviderProps['findJobsMenuLinks']} - The structured find jobs menu links.
 */ var getFindJobsMenuContent = function(baseURL, navigationLinkSection) {
    var findJobsContent = [
        {
            id: "get-started",
            kind: "group",
            items: getStartedCommonLinks(baseURL)
        }, 
    ];
    Object.entries(navigationLinkSection)// filter for jobsLinks only
    .filter(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 1), key = _param[0];
        return key === "jobsLinks";
    }).forEach(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), value = _param[1];
        var vgnLinkList = buildVgnLinkList(baseURL, "jobsLinks", value, false);
        var exploreJobsLabel = {
            kind: "label",
            value: "Explore jobs",
            id: "explore-jobs"
        };
        findJobsContent.push({
            id: "jobs-group",
            kind: "group",
            items: [
                exploreJobsLabel
            ].concat((0,_to_consumable_array/* default */.Z)(vgnLinkList))
        });
    });
    return {
        id: "find-jobs",
        title: "Find jobs",
        items: findJobsContent
    };
};

;// CONCATENATED MODULE: ./src/helpers/narrowSeoNavigationLinkSection.ts
var narrowSeoNavigationLinkSection = function(seoNavigationLinkSection) {
    if (seoNavigationLinkSection === null) return null;
    if (seoNavigationLinkSection.__typename === "SEONavigationLinkSectionSuccess") {
        return seoNavigationLinkSection;
    }
    return null;
};

// EXTERNAL MODULE: ./src/components/hooks/useResponsive.tsx
var useResponsive = __webpack_require__(19147);
;// CONCATENATED MODULE: ./src/components/common/SeoGlobalNavbar.tsx








var ref = config_default()(), NEXT_PUBLIC_APP_URL = ref.publicRuntimeConfig.NEXT_PUBLIC_APP_URL;
var SeoGlobalNavbar = function(param) {
    var _seoNavigationLinkSection = param.seoNavigationLinkSection, seoNavigationLinkSection = _seoNavigationLinkSection === void 0 ? null : _seoNavigationLinkSection;
    var isLargeViewport = (0,useResponsive/* useResponsive */.F)().isLargeViewport;
    var navLinkSection = narrowSeoNavigationLinkSection(seoNavigationLinkSection);
    var navMenuContent = navLinkSection ? navLinkSection.seoNavigationLinkSection : null;
    var findCareMenuLinks = navMenuContent ? getFindCareMenuContent(NEXT_PUBLIC_APP_URL, navMenuContent, isLargeViewport) : undefined;
    var findJobsMenuLinks = navMenuContent ? getFindJobsMenuContent(NEXT_PUBLIC_APP_URL, navMenuContent) : undefined;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(VisitorHeaderDataProvider/* default */.ZP, {
        baseUrl: NEXT_PUBLIC_APP_URL,
        logAnalyticsEvent: analyticsHelper/* logOrEnqueueEvent */.sw,
        findCareMenuLinks: findCareMenuLinks !== null && findCareMenuLinks !== void 0 ? findCareMenuLinks : undefined,
        findJobsMenuLinks: findJobsMenuLinks !== null && findJobsMenuLinks !== void 0 ? findJobsMenuLinks : undefined,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VisitorSEOHeader/* default */.Z, {})
    });
};


/***/ }),

/***/ 19147:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ useResponsive; }
/* harmony export */ });
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61730);

function useResponsive() {
    var isSmallViewport = (0,_mui_material__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(theme) {
        return theme.breakpoints.down("sm");
    }); // Mobile Devices
    var isMediumViewport = (0,_mui_material__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(theme) {
        return theme.breakpoints.between("sm", "lg");
    }); // Large Mobile and Tablets
    var isLargeViewport = (0,_mui_material__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(theme) {
        return theme.breakpoints.up("lg");
    }); // Small and Large Desktops
    return {
        isSmallViewport: isSmallViewport,
        isMediumViewport: isMediumViewport,
        isLargeViewport: isLargeViewport
    };
}



/***/ }),

/***/ 883:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sj": function() { return /* binding */ AmplitudeEvent; },
/* harmony export */   "UP": function() { return /* binding */ setPagePropertiesFromData; },
/* harmony export */   "rG": function() { return /* binding */ trackAmplitudeEvent; },
/* harmony export */   "sw": function() { return /* binding */ logOrEnqueueEvent; },
/* harmony export */   "xF": function() { return /* binding */ setDeviceDataFromHeaders; }
/* harmony export */ });
/* unused harmony exports WebPlatform, AMPLITUDE_DATE_FORMAT, AMPLITUDE_TIME_FORMAT, AnalyticsHelper, enqueEvent */
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _care_amplitude__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66537);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11752);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var universal_cookie__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65885);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64487);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42660);








var WebPlatform;
(function(WebPlatform) {
    WebPlatform["MW"] = "Mobile Web";
    WebPlatform["DT"] = "Desktop Web";
})(WebPlatform || (WebPlatform = {}));
var AmplitudeEvent;
(function(AmplitudeEvent) {
    AmplitudeEvent["applySegmentationFilter"] = "Apply Segmentation Filter";
    AmplitudeEvent["clickOnSegmentationFilter"] = "Click on Segmentation Filter";
    AmplitudeEvent["ctaInteracted"] = "CTA Interacted";
    AmplitudeEvent["providerProfileViewed"] = "Provider Profile Viewed";
    AmplitudeEvent["monetateAssetClicked"] = "Monetate Asset Clicked";
    AmplitudeEvent["seoPageViewed"] = "SEO Page Viewed";
    AmplitudeEvent["viatorCardClick"] = "SEO - Viator card clicked";
    AmplitudeEvent["testExposure"] = "Test Exposure";
    AmplitudeEvent["jobViewed"] = "Job Viewed";
    AmplitudeEvent["seoFeatureInteracted"] = "SEO Feature Interacted";
    AmplitudeEvent["errorViewed"] = "Error Viewed";
    AmplitudeEvent["iterableAssetViewed"] = "Iterable Asset Viewed";
    AmplitudeEvent["iterableAssetClicked"] = "Iterable Asset Clicked";
    AmplitudeEvent["lybBannerShown"] = "LYB Banner Shown";
    AmplitudeEvent["lybBannerClosed"] = "LYB Banner Closed";
})(AmplitudeEvent || (AmplitudeEvent = {}));
var publicRuntimeConfig = next_config__WEBPACK_IMPORTED_MODULE_0___default()().publicRuntimeConfig;
var AMPLITUDE_DATE_FORMAT = "MMDDYYYY";
var AMPLITUDE_TIME_FORMAT = "hh:mm A";
var initialized = false;
var AnalyticsHelper = /*#__PURE__*/ function() {
    "use strict";
    function AnalyticsHelper() {
        var _this = this;
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, AnalyticsHelper);
        this.amplitudeEventsQueue = [];
        this.setHeaderData = function(data) {
            _this.headerData = data;
        };
        this.setPageProperties = function(properties) {
            _this.pageProperties = properties;
        };
        this.getHeaderData = function() {
            return _this.headerData;
        };
        this.setEventInQueue = function(event) {
            _this.amplitudeEventsQueue.push(event);
        };
        this.getEventFromQueue = function() {
            return _this.amplitudeEventsQueue.shift();
        };
        this.getCommonData = function() {
            var cookies = new universal_cookie__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z();
            var ref = _this.headerData || {}, deviceOs = ref.device_os, isMobile = ref.is_mobile, mobileBrowser = ref.mobile_browser, mobileBrowserVersion = ref.mobile_browser_version;
            var ref1 = _this.pageProperties || {}, seoPageId = ref1.seo_page_id, screenName = ref1.screen_name, screenTemplate = ref1.screen_template, ServiceIdForMember = ref1.service_id_for_member, slots = ref1.slots;
            var czenVisitorId = cookies.get(_constants__WEBPACK_IMPORTED_MODULE_1__/* .CZEN_VISITOR_COOKIE_KEY */ .iN);
            var czenSessionId = cookies.get(_constants__WEBPACK_IMPORTED_MODULE_1__/* .CZEN_SESSION_COOKIE_KEY */ .Ih);
            var screenResolution = "".concat(window.screen.width, " x ").concat(window.screen.height);
            var viewportResolution = "".concat(window.innerWidth, " x ").concat(window.innerHeight);
            var visitorId = czenVisitorId || "VisitorIdNotFound";
            var CZENSessionId = czenSessionId || "SessionIdNotFound";
            var deviceModel = (deviceOs === null || deviceOs === void 0 ? void 0 : deviceOs.split(" ").length) > 1 ? deviceOs === null || deviceOs === void 0 ? void 0 : deviceOs.split(" ")[0] : deviceOs;
            var webPlatform = isMobile === "true" ? WebPlatform.MW : WebPlatform.DT;
            var commonData = {
                czen_session_id: CZENSessionId,
                device_model: deviceModel,
                environment: publicRuntimeConfig.SENTRY_ENV,
                language: navigator.language,
                os_name: mobileBrowser,
                os_version: mobileBrowserVersion,
                referer: document.referrer,
                rendered_by: "seo-mfe",
                screen_name: screenName,
                screen_resolution: screenResolution,
                screen_template: screenTemplate,
                seo_page_id: seoPageId,
                service_id_for_member: ServiceIdForMember,
                slots: slots,
                userAgent: navigator.userAgent,
                viewport_resolution: viewportResolution,
                visitor_id: visitorId,
                web_platform: webPlatform
            };
            return commonData;
        };
        this.logEvent = function(payload) {
            try {
                if (!initialized) {
                    var careAnalyticsConfig = {
                        analyticsEnabled: publicRuntimeConfig.ANALYTICS_ENABLED === "true",
                        key: publicRuntimeConfig.AMPLITUDE_API_KEY,
                        commonData: _this.getCommonData()
                    };
                    (0,_care_amplitude__WEBPACK_IMPORTED_MODULE_4__/* .init */ .S1)(careAnalyticsConfig);
                    initialized = true;
                    // session id is available with a small delay after amplitude initialization
                    setTimeout(function() {
                        var ref;
                        var amplitudeSessionId = (ref = (0,_care_amplitude__WEBPACK_IMPORTED_MODULE_4__/* .getInstance */ .s8)()) === null || ref === void 0 ? void 0 : ref.getSessionId();
                        if (amplitudeSessionId) {
                            (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .configureScope */ .e)(function(scope) {
                                var user = scope.getUser();
                                scope.setUser((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, user), {
                                    amplitudeSessionId: amplitudeSessionId
                                }));
                            });
                        }
                    });
                }
                var logEventPayload = {
                    name: payload.name,
                    data: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, payload.data)
                };
                (0,_care_amplitude__WEBPACK_IMPORTED_MODULE_4__/* .logEvent */ .Kz)(logEventPayload);
            } catch (e) {
                (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .captureException */ .Tb)(e);
            }
        };
    }
    AnalyticsHelper.init = function init() {
        if (this.analytics === undefined) {
            this.analytics = new AnalyticsHelper();
        }
        return this.analytics;
    };
    return AnalyticsHelper;
}();
var enqueEvent = function(event) {
    var analyticsInstance = AnalyticsHelper.init();
    analyticsInstance.setEventInQueue(event);
};
var dequeEvent = function() {
    var analyticsInstance = AnalyticsHelper.init();
    return analyticsInstance.getEventFromQueue();
};
var logOrEnqueueEvent = function(param) {
    var name = param.name, data = param.data;
    var analyticsInstance = AnalyticsHelper.init();
    // If name or data is not provided, do not log or enqueue the event
    if (!name || !data) {
        return;
    }
    if (analyticsInstance.getHeaderData() === undefined) {
        enqueEvent({
            name: name,
            data: data
        });
    } else {
        analyticsInstance.logEvent({
            data: data,
            name: name
        });
    }
};
var trackAmplitudeEvent = function() {
    var name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    logOrEnqueueEvent({
        name: name,
        data: data
    });
};
var setPagePropertiesFromData = function(properties) {
    var analyticsInstance = AnalyticsHelper.init();
    analyticsInstance === null || analyticsInstance === void 0 ? void 0 : analyticsInstance.setPageProperties(properties);
};
var setDeviceDataFromHeaders = function(data) {
    var analyticsInstance = AnalyticsHelper.init();
    analyticsInstance.setHeaderData(data);
    var eventsPresentInQueue = analyticsInstance.amplitudeEventsQueue.length;
    if (eventsPresentInQueue > 0) {
        // eslint-disable-next-line no-plusplus
        for(var i = 0; i < eventsPresentInQueue; i++){
            var event = dequeEvent();
            if ((event === null || event === void 0 ? void 0 : event.name) && (event === null || event === void 0 ? void 0 : event.data)) {
                trackAmplitudeEvent(event.name, event.data);
            }
        }
    }
    return data;
};


/***/ })

}]);